<div id="services" class="services-area">
  <div class="container">
    <div class="section-title">
      <h2>Nuestros <span>Proyectos</span></h2>
      <p>Estos son algunos de los proyectos en los que ha trabajado nuestro centro de investigaciones.</p>
    </div>
    <div class="projects-list">
      @for (project of projects | paginate: { id: 'projects', itemsPerPage: tamanoTabl.value, currentPage: page }; track project) {
        <div class="project-item" [class.project-item--linked]="project.link" (click)="openLink(project.link)">
          <div class="single-services">
            <div class="services-img">
              <img [src]="project.coverUrl" [alt]="project.title" loading="lazy">
            </div>
            <div class="services-content">
              <h3>{{ project.title }}</h3>
              <div class="project-description" [innerHTML]="project.description"></div>
            </div>
          </div>
        </div>
      }
    </div>

    @if (projects.length > 0) {
      <div class="pagination-controls">
        <div class="items-per-page">
          <label id="projects-page-size-label" (click)="pageSizeSelect.focus()">Mostrar:</label>
          <mat-select #pageSizeSelect
            class="page-size-select"
            panelClass="publication-select-panel publication-page-size-panel"
            aria-labelledby="projects-page-size-label"
            [formControl]="tamanoTabl"
            (selectionChange)="page = 1">
            <mat-option value="5">5</mat-option>
            <mat-option value="10">10</mat-option>
            <mat-option value="15">15</mat-option>
          </mat-select>
          <span>por página</span>
        </div>
        <pagination-controls
          id="projects"
          (pageChange)="page = $event"
          previousLabel="Anterior"
          nextLabel="Siguiente">
        </pagination-controls>
      </div>
    }
  </div>
</div>
